module.exports = __webpack_public_path__ + "img/retrieve-password.546a38cf.png";